/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=92444930
export const turntablePage = createAsyncThunk(
  'LudoTurntable/turntablePage',
  async (p: any, store: any) => {
    const resp = await http.post('/gamestore/common/turntable_page', {
      ...store.getState().env.deviceinfo,
      ...p,
      game_tag: 'ludo',
    })
    return resp.data
  }
)

export const turntableRoll = createAsyncThunk(
  'LudoTurntable/turntableRoll',
  async (p: {is_plus: boolean}, store: any) => {
    const resp = await http.post('/gamestore/common/turntable_roll', {
      ...store.getState().env.deviceinfo,
      game_tag: 'ludo',
      ...p,
    })
    return resp.data
  }
)

// 一个通用的、游戏方面的任务去完成按钮的接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=91711615
export const goto_complete = createAsyncThunk(
  'LudoTurntable/goto_complete',
  async (arg: {room_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        scheme: number
        err_msg: string
      }>
    >('/gamestore/common/game_mission_goto_complete', {
      ...store.getState().env.deviceinfo,
      ...arg,
      from: 'turntable_activity_ludo',
    })
    return resp.data.data
  }
)

const initialState: {
  reward_map: Array<any>
  index: number
  member: {
    id: number
    name: string
    avatar: string
    balance: number
  }
  roll_score_sum: number // 摇动骰子的积分总和,这次是时间
  roll_score: number // 单次摇骰子需要的值
  roll_score_plus: number // 转一圈需要的值
  turntable_mission: {
    img_url: string
    target: number
    current: number
    status: number // 2表示为可领奖
  }
  activity_date: string
  is_over: boolean // 是否活动结束
} = {
  reward_map: [],
  index: 20,
  member: {
    id: 0,
    name: '',
    avatar: '',
    balance: 0,
  },
  roll_score_sum: 0,
  roll_score: 0,
  roll_score_plus: 0,
  turntable_mission: {
    img_url: '',
    target: 0,
    current: 0,
    status: 2,
  },
  activity_date: '',
  is_over: false,
}

export const LudoTurntableSlice = createSlice({
  name: 'LudoTurntable',
  initialState,
  reducers: {
    setData(state, action) {
      Object.assign(state, action.payload)
    },
    setMission(state, action) {
      Object.assign(state.turntable_mission, action.payload)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(turntablePage.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
  },
})

export default LudoTurntableSlice.reducer
export const {setMission, setData} = LudoTurntableSlice.actions
